import { render, staticRenderFns } from "./startFrom.vue?vue&type=template&id=4ec33a2a"
import script from "./startFrom.vue?vue&type=script&lang=js"
export * from "./startFrom.vue?vue&type=script&lang=js"
import style0 from "./startFrom.vue?vue&type=style&index=0&id=4ec33a2a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports